module.exports = __webpack_public_path__ + "img/IMG_1962_P_L_Wood_MockedUp.675e3ecb.jpg";